import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

export const useConfirmResetPasswordMutation = () => {
  return useMutation({
    mutationFn: (payload: any) =>
      axiosInstance
        .patch("/admins/confirm-reset", payload)
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {},
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
